

























































import { Vue, Component } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import UserService from '@/services/UserService'
import { User } from '@/interfaces/UserInterfaces'
import MainLogos from '@/components/common/layout/MainLogos.vue'
import GuestLogos from '@/components/common/layout/GuestLogos.vue'
import LangSwitcher from '@/components/common/layout/LangSwitcher.vue'
import ExitImpersonate from '@/components/impersonate/ExitImpersonate.vue'

@Component({
  name: 'UserHeader',
  components: {
    MainLogos,
    GuestLogos,
    LangSwitcher,
    ExitImpersonate
  }
})
export default class UserHeader extends Vue {
  @Getter('user/isAuthenticated')
  private isAuthenticated!: boolean

  @Getter('user/isImpersonated')
  private isImpersonated!: boolean

  @Getter('user/currentUser')
  user!: User

  isActiveAccountMenu: boolean = false

  mounted () : void {
    document.addEventListener('click', (event: Event) => {
      const element: HTMLElement | null = document.getElementById('account-drop-down')

      if (!element) {
        return
      }

      if (event.target instanceof Node && !element.contains(event.target)) {
        this.isActiveAccountMenu = false
      }
    })
  }

  logout () : void {
    this.$auth.logout().then(async () : Promise<void> => {
      await UserService.logout()
      this.$router.push({ name: 'home' })
    })
  }

  get userName (): string {
    return this.user && this.user.candidateNumber
      ? this.user.candidateNumber
      : ''
  }
}
